import { create } from 'zustand'

type ConnectionStatusState = {
  slowRequestsCount: number
  increaseSlowRequests: () => void
  decreaseSlowRequests: () => void
}

export const useConnectionStatusStore = create<ConnectionStatusState>()(
  set => ({
    slowRequestsCount: 0,
    increaseSlowRequests: () =>
      set(state => ({ slowRequestsCount: state.slowRequestsCount + 1 })),
    decreaseSlowRequests: () =>
      set(state => ({
        slowRequestsCount: Math.max(state.slowRequestsCount - 1, 0)
      }))
  })
)
